import React from "react";
import { Outlet } from "react-router-dom";

const BehindPaywallLayout: React.FunctionComponent = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default BehindPaywallLayout;
